import React from 'react';
const facts = [{
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '300+',
  label: 'Pages of written practices'
}, {
  value: '1–6',
  label: 'Stunt levels covered'
}, {
  value: '5',
  label: 'Season phases covered'
}];
export function SocialProofBar() {
  return <section className="w-full bg-navy" data-id="element-181" data-mp="25suajgoklzlz">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-182" data-mp="25tvnjqp5cw6c">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-navy-line bg-navy-line sm:grid-cols-4" data-id="element-183" data-mp="32iuun2dzvrwy">
          {facts.map(fact => <div key={fact.label} className="bg-navy px-4 py-5 text-center" data-id="element-184" data-mp="2xkteoqbv88pp">
              <div className="font-display text-3xl sm:text-4xl leading-none text-gold" data-id="element-185" data-mp="2th3ndt3t3d0z">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-white/60" data-id="element-186" data-mp="2olobh6pczr77">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}